import React from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import {
  Assignment,
  Build,
  AttachMoney,
  Chat,
  Badge,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import { useState, useMemo } from "react";
import Footer from "../../../layout/Footer";
import ContractorTopNav from "./ContractorTopNav";

const ContractorShell = ({ children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const ppState = useSelector((state) => state[currentSession]?.pp);
  const unreadNotifications = ppState?.ppNotifications?.unreadCount || 0;

  const [bottomNavValue, setBottomNavValue] = useState(0);

  const MemoizedFooter = useMemo(() => <Footer />, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        marginLeft: { lg: "280px" }, // Account for sidebar width
        width: { lg: "calc(100% - 280px)" }, // Adjust width to account for sidebar
      }}
    >
      <ContractorTopNav />
      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: "grey.50",
          overflowY: "auto",
          minHeight: 0,
        }}
      >
        {children || <Outlet />}
      </Box>
      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <Paper
          sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}
          elevation={3}
        >
          <BottomNavigation
            value={bottomNavValue}
            onChange={(event, newValue) => {
              setBottomNavValue(newValue);
              const routes = [
                "/pp/contractor/permits",
                "/pp/contractor/inspections",
                "/pp/contractor/uploads",
                "/pp/contractor/messaging",
              ];
              navigate(routes[newValue]);
            }}
            showLabels
          >
            <BottomNavigationAction label="Permits" icon={<Assignment />} />
            <BottomNavigationAction label="Inspections" icon={<Build />} />
            <BottomNavigationAction label="Uploads" icon={<AttachMoney />} />
            <BottomNavigationAction
              label="Messages"
              icon={
                <Badge badgeContent={unreadNotifications} color="error">
                  <Chat />
                </Badge>
              }
            />
          </BottomNavigation>
        </Paper>
      )}
      {MemoizedFooter}
    </Box>
  );
};

export default ContractorShell;
